const WISHLIST_KEY = "asher_shop_wishlist";

export function readWishlist() {
  try {
    const raw = window.localStorage.getItem(WISHLIST_KEY);
    const parsed = JSON.parse(raw || "[]");
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}

export function writeWishlist(productIds) {
  try {
    const uniqueIds = Array.from(new Set((productIds || []).map(String)));
    window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(uniqueIds));
    return uniqueIds;
  } catch {
    return [];
  }
}

export function toggleWishlist(productId) {
  const targetId = String(productId);
  const existing = readWishlist();
  if (existing.includes(targetId)) {
    return writeWishlist(existing.filter((id) => id !== targetId));
  }
  existing.unshift(targetId);
  return writeWishlist(existing);
}

export function pruneWishlist(availableIds) {
  const allowed = new Set((availableIds || []).map(String));
  return writeWishlist(readWishlist().filter((id) => allowed.has(id)));
}

